import { render } from "./StrategyAdditionalSettings.vue?vue&type=template&id=aa6ad5d2"
import script from "./StrategyAdditionalSettings.vue?vue&type=script&lang=js"
export * from "./StrategyAdditionalSettings.vue?vue&type=script&lang=js"

import "./StrategyAdditionalSettings.vue?vue&type=style&index=0&id=aa6ad5d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__